type SpacingType = (size: number) => string;
/**
 * A spacing token utility, space scale is space(50) = 0.25rem
 */
export const space: SpacingType = (size: number) => {
  const isValidToken = size % 50 === 0;
  if (!isValidToken) {
    throw 'Spacing token must be a multiple of 50';
  }
  return `${(size * 0.25) / 50}rem`;
};
